import { SITE, FLEET } from '../data/fleet'

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="wrap hero__inner">
        <div>
          <span className="eyebrow eyebrow--dark">
            Trailer rental in Melissa, TX &middot; Pickup free
          </span>

          <h1>
            Rent the trailer. <em>Skip</em> the rental yard.
          </h1>

          <p className="hero__sub">
            Trailer rental in Melissa, TX. Pick up free at our lot with 24/7
            access, or get delivery across DFW. Dump, equipment, and utility
            trailers at published rates &mdash; no paperwork line, no yard
            hours.
          </p>

          <div className="hero__actions">
            <a className="btn btn--primary" href="#fleet">
              See the fleet
            </a>
            <a className="btn btn--ghost" href={SITE.phoneHref}>
              Call {SITE.phone}
            </a>
          </div>

          <p className="hero__terms">
            You load it. You haul it. You dump it. We rent the equipment.
          </p>
        </div>

        <div className="hero__side">
          <img
            className="hero__logo"
            src="/logo.png"
            alt="Golden Mule Trailer Rentals"
            width="800"
            height="519"
          />

          <div className="board">
            <div className="board__head">
              <span>The fleet</span>
              <span>Pickup free</span>
            </div>

            {FLEET.map((trailer) => (
              <div className="board__row" key={trailer.id}>
                <span className="board__unit">{trailer.unit}</span>
                <span className="board__desc">{trailer.name}</span>
                <span className="board__status">${trailer.dayRate}/day</span>
              </div>
            ))}

            <p className="board__foot">
              Call or send a request and we&rsquo;ll confirm availability.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
